import { GooglePlacesResult, Location, PayRateType } from "./Classes";

function formatPlacesComponents(result: GooglePlacesResult){
	var place : any = {
		name: result.name,
		place_id: result.place_id,
		phone: null,
		street: null,
		exterior_number: null,
		interior_number: null,
		neighborhood: null,
		city: null,
		state: null,
		zipcode: null,
		country: null,
		lattitude: null,
		longitude: null,
	}
	var place_identifiers: any = {
		street: {
			type: ['street_address', 'route'],
		},
		exterior_number: {
			type: 'street_number'
		},
		interior_number: {
			type: ['room', 'subpremise']
		},
		neighborhood: {
			type: ['neighborhood', 'sublocality']
		},
		city: {
			type: 'locality'
		},
		zipcode: {
			type: 'postal_code'
		},
		state: {
			long_name: true,
			type: 'administrative_area_level_1'
		},
		country: {
			type: 'country'
		}
	}

	place.longitude = result.geometry.location.lng();
	place.lattitude = result.geometry.location.lat();

	for(var i of result.address_components){
		for(var k of Object.keys(place_identifiers)){
			var types = place_identifiers[k].type;
			if(!Array.isArray(types)) types = [types];
			for(var t of types){
				if(i.types.indexOf(t)!=-1){
					if(k=='address_2' && place['street']==i.long_name) continue;
					place[k] = place_identifiers[k].long_name===false ? i.short_name : i.long_name
					break;
				}
			}
		}
	}
	return place as Location;
}

function getPayRateTypeLocale(rate_type: PayRateType){
	switch(rate_type){
		case PayRateType.FIXED: return 'Fijo';
		case PayRateType.HOURLY: return 'Hora';
		case PayRateType.DAILY: return 'Diario';
		default: return 'UNKNOWN';
	}
}

function formatAddress(location: Location){
	return [
		`${location.street} ${location.exterior_number || ''}`,
		location.interior_number && `Interior ${location.interior_number}`,
		location.neighborhood,
		location.zipcode && `CP ${location.zipcode}`,
		location.city,
		location.state,
		location.country
	].filter(Boolean).join(', ');
}

function distance(lat1: number, lon1: number, lat2: number, lon2: number, unit: string) {
	if ((lat1 == lat2) && (lon1 == lon2)) {
		return 0;
	}
	else {
		var radlat1 = Math.PI * lat1/180;
		var radlat2 = Math.PI * lat2/180;
		var theta = lon1-lon2;
		var radtheta = Math.PI * theta/180;
		var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
		if (dist > 1) {
			dist = 1;
		}
		dist = Math.acos(dist);
		dist = dist * 180/Math.PI;
		dist = dist * 60 * 1.1515;
		if (unit=="K") { dist = dist * 1.609344 }
		if (unit=="N") { dist = dist * 0.8684 }
		return dist;
	}
}

var getDurationTime = (date_start: number, date_end: number)=>{
	var seconds = date_end-date_start;
	if(seconds<=0) return null;
	if(seconds<=3600){
		return '~1 hora';
	}else if(Math.ceil(seconds/3600)>=24){
		var days = Math.floor(Math.ceil(seconds/3600)/24);
		return `${days} dia${days==1 ? '' : 's'}`	
	}else if(seconds>3600){
		return `${Math.ceil(seconds/3600)} horas`
	}
}

export {
	distance,
	formatAddress,
   formatPlacesComponents,
	getDurationTime,
	getPayRateTypeLocale,
}